import AbstractAsyncTablePage from '../abstract-async-table-page';
import TireWarrantySearchForm from '../../components/tire-warranty/tire-warranty-search-form';
import SavedTireWarrantyDeleteModal from '../../components/tire-warranty/saved-tire-warranty-delete-modal';
import Table from '../../components/shared/table';
import HTMLTemplateHelper from '../../helpers/html-template-helper';
import TireWarrantyData from '../../model/tire-warranty-data';
import MessageHelper from '../../helpers/message-helper';
import { formatDate } from '../../helpers/utils';

export default class TireWarrantySavedPage extends AbstractAsyncTablePage {

  private readonly savedTireWarrantyDeleteModal: SavedTireWarrantyDeleteModal;
  protected readonly searchForm: TireWarrantySearchForm;
  protected readonly table: Table;
  protected readonly tableColumnConfiguration: DataTables.ColumnDefsSettings[] = [
    {
      targets: 0,
      data: (data: TireWarrantyData, type: string): string | number => {
        if (type === 'sort') {
          return data.saveDate;
        }
        return formatDate(new Date(data.saveDate));
      },
    },
    { targets: 1, data: 'customerContact' },
    { targets: 2, data: 'reference' },
    { targets: 3, data: 'statusName' },
    { targets: 4, data: 'reasonName' },
    { targets: 5, data: (data: TireWarrantyData): string | null => data.vehicle?.vin ?? null },
    { targets: 6, data: (data: TireWarrantyData): string | null => data.vehicle?.licensePlate ?? null },
    {
      targets: 7,
      data: (data: TireWarrantyData): string => HTMLTemplateHelper.createLinkButton({
        text: MessageHelper.getMessage('common.open'),
        buttonClass: '-primary -compact',
        href: `${window.ACC.config.encodedContextPath}/tireWarranty/${data.code}`,
      }).outerHTML,
    },
    {
      targets: 8,
      data: (data: TireWarrantyData): string => HTMLTemplateHelper.createButton({
        text: MessageHelper.getMessage('common.remove'),
        textClass: 'sr-only',
        icon: 'fas fa-times',
        buttonClass: '-clear -compact js-removeSavedTireWarranty',
        dataAttributes: { tireWarrantyCode: data.code },
      }).outerHTML,
    },
  ];

  constructor(private readonly body: JQuery) {
    super();
    this.searchForm = new TireWarrantySearchForm(body.find('.js-filters') as JQuery<HTMLFormElement>);
    this.savedTireWarrantyDeleteModal = new SavedTireWarrantyDeleteModal(body);
    this.table = new Table(body.find('.js-table'), this.tableColumnConfiguration);
    this.bindAsyncData();
  }
}
